
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projector-rental",
      function () {
        return require("private-next-pages/projector-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projector-rental"])
      });
    }
  